import React from 'react';
import type TTab from './types/TTab';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import { TextLarge } from '../Text';
import keyboardKeys from '../../constants/keyboardKeys';

const Tab = ({ label, onClick, icon, isActive, id, ...otherProps }: TTab) => {
  const { ENTER } = keyboardKeys;
  const color = isActive ? 'tab-bar-selected-default' : 'tab-bar-unselected-default';

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === ENTER || event.key === ' ') {
      event.preventDefault();
      onClick?.(); // Activate tab on Enter/Space key
    }
  };
  return (
    <Box
      as="li"
      name="TabNext"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      modifiers={isActive ? ['active'] : []}
      role="tab"
      aria-selected={isActive}
      tabIndex={isActive ? 0 : -1}
      aria-controls={`tab-${id}`}
      id={`tab-${id}`}
      {...otherProps}
    >
      {icon && <Icon name={icon} size="m" color={color} />}
      <TextLarge as={isActive ? 'strong' : 'span'} color={color}>
        {label}
      </TextLarge>
    </Box>
  );
};

export default Tab;
